import { deleteReq, postReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { PagedResponseModel, BaseResponseModel } from "@/models/core.model";
import {
  RunningClubCaptainProfile,
  RunningClubCaptainProfilePaginationFilterRequest,
  UpsertRunningClubCaptainProfile
} from '@/models/running-club-captain-profile.model';

export const getPagedRunningClubCaptainProfiles = async (input: RunningClubCaptainProfilePaginationFilterRequest): Promise<PagedResponseModel<RunningClubCaptainProfile>> => {
  return await getReq(createUrl("a/RunningClub/CaptainProfile/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

export const getRunningClubCaptainProfile = async (id: number): Promise<BaseResponseModel<RunningClubCaptainProfile>> => {
  return await getReq(createUrl(`a/RunningClub/CaptainProfile/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const upsertRunningClubCaptainProfile = async (input: UpsertRunningClubCaptainProfile): Promise<BaseResponseModel<RunningClubCaptainProfile>> => {
  return await postReq(createUrl("a/RunningClub/CaptainProfile/Upsert"),
    input
  ).then((res: any) => res.data);
};

export const deleteRunningClubCaptainProfile = async (id: number): Promise<BaseResponseModel<null>> => {
  return await deleteReq(createUrl(`a/RunningClub/CaptainProfile/Delete/${id}`),
  ).then((res: any) => res.data);
};
